import {CommandStrategy} from './base/CommandStarategy';
import {PieMenuIcons} from '../PieMenuIcons';
import {Card} from '../../../game_table/table_objects/stacks/Card';
import {Stack} from '../../../game_table/table_objects/stacks/Stack';
import {ApiSendCommandsController} from '../../../../../controllers/ApiSendCommandsController';
import {CardSelector} from '../../../../../controllers/CardSelector';
import {DynamicData} from '../../../../../data/DynamicData';

export class FlipCardsCommandStarategy extends CommandStrategy
{
    constructor() {
        super({iconId: PieMenuIcons.FLP, hint: 'Flip (F)'});
    }

    isApplicable(card: Card | undefined, stack: Stack | undefined): boolean {
        return CardSelector.selectedCards.length > 0 && !stack && DynamicData.settings.canTableFlipCards;
    }

    execute(commandIndex: number): void {
        ApiSendCommandsController.flipCards(CardSelector.selectedCards);
    }
}
